import React from 'react'

import './Loading.css'

const Loading = ({ width = 200, height = 200, children }) => {
  return (
    <div className="loading-container" style={{ width, height }}>
      <div className="loading" />
      <div className="loading-info">{children}</div>
    </div>
  )
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading.js